
import { Vue, Component } from 'vue-property-decorator'
import Customer from '@/types/customer'
import Column from '@/types/column'
import { can } from '@/globalFunctions'

@Component({
  methods: { can },
  components: {}
})

export default class CustomerShowDetailsTab extends Vue {
  settings = {
    routeNames: { list: 'customers', show: 'customerShow', edit: 'customerEdit' },
    routeParamKey: 'customerId',
    functionNames: { setCurrent: 'setCurrentCustomer', save: 'saveCustomer' },
    getterNames: { current: 'currentCustomer', loading: 'loadingCustomer', errors: 'customerErrors' }
  }

  columns:Column[] = [
    {
      title: 'Naam',
      key: 'full_name',
      dataIndex: 'full_name',
      filters: [],
      sorter: false,
      sortDirections: ['ascend', 'descend']
    },
    {
      title: 'E-mailadres',
      key: 'email',
      dataIndex: 'email',
      filters: [],
      sorter: false,
      sortDirections: ['ascend', 'descend']
    },
    {
      title: 'Telefoon',
      key: 'phone',
      dataIndex: 'phone',
      filters: [],
      sorter: false,
      sortDirections: ['ascend', 'descend']
    },
    {
      title: 'Contractant',
      key: 'contractor',
      scopedSlots: { customRender: 'contractor' },
      filters: [],
      sorter: false,
      sortDirections: ['ascend', 'descend']
    },
    {
      title: 'Actie\'s',
      key: 'action',
      scopedSlots: { customRender: 'action' }
    }
  ]

  navigateTo (id:number, edit:boolean|null) : void {
    if (edit) {
      this.$router.push({ name: 'customerUserEdit', params: { customerUserId: id.toString() } })
    } else {
      this.$router.push({ name: 'customerUserShow', params: { customerUserId: id.toString() } })
    }
  }

  onRowClick (rowData:{id:number}) : { on: { click: () => void }} {
    return {
      on: {
        click: () => {
          const keyboard = window.event as KeyboardEvent
          if (can('customers.users.edit')) {
            const route = this.$router.resolve({ name: 'customerUserEdit', params: { customerUserId: rowData.id.toString() } })
            window.open(route.href, keyboard.ctrlKey ? '_blank' : '_self')
          } else if (can('customers.users.view')) {
            const route = this.$router.resolve({ name: 'customerUserShow', params: { customerUserId: rowData.id.toString() } })
            window.open(route.href, keyboard.ctrlKey ? '_blank' : '_self')
          }
        }
      }
    }
  }

  get currentItem () : Customer {
    return this.$store.getters[this.settings.getterNames.current]
  }

  get errors () : { [key:string]: string[] } {
    return this.$store.getters[this.settings.getterNames.errors]
  }
}
